<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext pb-50">
      <div class="container">
        <div class="area_wrap">
          <accordion>
            <accordion-item>
              <template slot="accordion-trigger">
                <accordion>
                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>1년 전에는 갑상선 양성결절이라고 했는데 지금은 갑상선암이라고 합니다. 어떻게 된 건가요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선 양성 결절이 시간이 지남에 따라 암으로 변질되어 진단이 바뀌는 것은 아닙니다.</span>
                        <span>갑상선 결졀의 암 확률을 검사하는 세침흡인 세포검사의 정확도는 97%라고 알려져 있어, 약 3% 정도는 진단이
                              잘못 되었을 가능성이 있습니다.
                              그래서 세포검사에서 양성결절로 나왔더라도 <b>정기적인 초음파검사를 통해 결절의 변화 모습을 추적관찰</b>
                              하여야 합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>목에 무언가 걸린 느낌이고 기침이 나는데 갑상선암과 관련이 있을까요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>목 앞부분에 만져지는 혹은 없지만 목에 무언가 걸리는 느낌과 기침이 있다면 갑상선암 보다는 다른 후두 질환일 가능성이 높습니다. 대표적인 질병은 <b>인후두 역류증</b>입니다.</span>
                        <span>인후두 역류증은 위산이 역류하면서 후두와 식도 입구에 염증과 부종이 생겨 목 안 이물감, 기침, 가래 등을 유발하는 흔한 질환입니다.</span>
                        <span>갑상선암 때문에 생기는 이물감과 기침은 <b>암의 크기가 커서 주위 조직을 압박하거나 침습해야만</b> 생길 수 있으므로 만져지는 혹 없이 이물감과 기침만 있다면 갑상선암에 의한 증상일 가능성은 매우 작습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암 수술 후에는 꼭 갑상선호르몬을 복용해야 하나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>양쪽 갑상선을 전절제했다면 반드시 갑상선호르몬제를 먹어야 합니다. 하지만 한 쪽 갑상선만 절제했고 혈중 갑상선호르몬의 농도가 정상이라면 갑상선호르몬제를 복용하지 않아도 됩니다.</span>
                        <span>반절제 수술 후 갑상선 기능이 정상으로 유지될 확률은 85% 정도입니다.</span>
                        <span>일부에서는 갑상선 반절제를 했고 갑상선 기능검사가 정상이어도 갑상선호르몬을 복용하라고 합니다. <b>갑상선호르몬제를 복용</b>하면 뇌하수체에 나오는 <b>갑상선자극호르몬의 수치가 감소</b>하는데,
                          <b>갑상선자극호르몬의 수치가 낮게 유지되면 갑상선암의 성장도 더뎌집니다.</b></span>
                      </div>

                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>침샘종양의 일반적인 증상은 무엇인가요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span><b>침샘종양은 양성종양(암이 아닌 종양)과 악성종양인 침샘암</b>으로 나뉩니다. 이러한 침샘 종양은
                          <b>귀 밑이나 턱 밑에 만져지는 혹</b>이 있으면 의심할 수 있습니다.</span>
                        <span>침샘에는 침을 만들고 분비하는 다양한 종류의 세포들이 모여 있어서,
                          침샘에 생기는 종양도 매우 다양합니다. <b>암이 아닌 양성종양이 10배 이상 흔하지만,</b>
                          암 또한 종류가 매우 다양해 세계보건기구(2004년)에서 분류해 둔 것만 <b>25종</b>이나 됩니다.</span>
                        <span>너무나 다양한 침샘 양성종양과 침샘암이 있어 증상이나 세포검사만으로는
                          진단에 한계가 있기 때문에 <b>정확한 진단과 치료를 위해서는 수술이 필요합니다.</b></span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>세침흡인검사를 했는데 암은 아니었습니다. 이후 어떻게 관리해야 하나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선결절의 세침흡인세포검사의 정확도는 <b>약 97%</b>라고 합니다. 상당히 정확한 검사이므로 일단 안심해도 좋습니다.</span>
                        <span>그렇지만 초음파 검사에서 <b>결절의 모양이 매우 좋지 않거나 추적관찰 중 점점 커지는 경우</b>에는 다시 검사를 받아야 할 수 있습니다.</span>
                        <span>따라서 세침흡인세포검사에서 암이 아닌 양성 결절로 나왔어도 <b>정기적으로 초음파검사를 하면서 추적 관찰</b>해야 합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>엄마가 갑상선암에 걸렸다면 자녀도 갑상선암에 걸릴 가능성이 높나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선암이 가족 내에서 여러 명이 생기는 경우가 종종 있지만, <b>유전되는 병은 아닙니다.</b></span>
                        <span>특히 갑상선암의 대부분을 차지하는 <b>유두암</b>의 경우, 갑상선암 가족력이 있다고 해서 가족들의 갑상선 초음파검사를 꼭 해야 할 필요는 없습니다.</span>
                        <span>다만 드문 갑상선암인 수질암의 경우에는 유전성인 경우가 있으므로, <b>수질암으로 진단 받은 경우에는 유전자 검사</b>를 시행해야 합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>편도절제술을 하면 다시는 인두염에 걸리지 않나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>일반적인 편도절제술은 목 안에 있는 편도 중 일부인 구개편도를 제거하는 수술입니다.</span>
                        <span>편도절제술 후에는 구개편도에 생기는 심각한 편도염 및 편도주위 농양은 생기지 않습니다.</span>
                        <span>남아있는 설편도, 인두편도, 이관편도 등에는 편도염이나 인두염이 생길 수 있습니다.</span>
                        <span>다만 <b>수술 전보다 염증이 생기는 빈도나 심각한 정도가 매우 감소</b>하게 됩니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선을 다 제거했는데, 왜 재발하나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선암 역시 다른 암처럼 림프절을 통해 전이될 수 있습니다. 갑상선 조직 전체와 전이가 의심되는 림프절 구역을 제거한다고 해도,
                          세포 단위의 작은 암 조직은 현재 의학기술로는 발견할 수 없기 때문에 어딘가 남았을 가능성이 있습니다.</span>
                        <span>따라서 진행된 갑상선암에는 수술 후 잔여 갑상선 조직과 암세포를 제거하기 위해 방사성 요오드치료를 시행합니다.</span>
                        <span>수술과 방사성 요오드치료 후에도 드물게 재발할 수 있습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암. 재발해도 다시 치료가 가능한가요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>가능합니다. 갑상선암은 다른 암과 달라서, 재발한 경우에도 적극적으로 치료하면 좋은 결과를 얻을 수 있습니다.</span>
                        <span>재발에는 갑상선 잔존부위 재발과 림프절 재발이 있고, 드물지만 폐나 뼈에 전이되어 재발 하는 경우도 있습니다. 각각의 경우에 적절한 수술과 방사성요오드치료가 시행되고,
                          경우에 따라서는 외부 방사선치료를 할 수도 있습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암을 수술하지 않고 약물로 치료할 수 있는 방법은 없나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>작은 갑상선암은 아무 치료를 하지 않아도 95.1%의 환자에서는 5년동안 3mm이상 자라지 않고,
                          98.3%의 환자에서는 림프절 전이가 발견되지 않습니다. 작은 갑상선암을 그냥 내버려 두어도 대부분 문제가 없으므로
                          치료하지 않고 관찰하여도 됩니다. 하지만 <b>수술 대신 약물로 치료하라는 의미는 아닙니다.</b> 크기가 5mm 혹은 1cm 이하의
                          작은 결절은 세포검사가 안되는 경우도 많기 때문에 추후 조금 더 커졌을 때 수술을 해도 괜찮습니다. <b>크기가 작은
                            갑상선암을 비수술로 치료한다고 약물이나 물리치료로 치료를 해서는 안됩니다.</b></span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>고령인 경우에도 갑상선암수술이 가능할까요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선암 수술을 하기 전, 다른 질병으로 인해 복용 중인 약을 먼저 확인하게 됩니다.
                          복용 중인 약 중에는 수술 전에 중단해야 할 것도 있기 때문에 반드시 <b>건강상태 및 약 복용,
                            다른 질병 유무</b> 등을 전체적으로 체크해야 합니다. 나이가 많다 할지라도 <b>충분히 마취를 통한 수술이 가능</b>합니다.</span>
                        <span>고령자의 경우, 마취와 수술에 대한 위험성과 수술에 따른 효과 등을 충분히 설명하고
                          수술 여부를 최종 결정 할 때 환자의 올바른 판단이 이루어질 수 있도록 합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암 발생이 먹는 것과 관련이 있나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>김, 다시마, 미역 같이 요오드를 많이 섭취하는 지역에서는 갑상선 유두암이 잘 발병하고,
                          요오드 섭취가 부족한 지역에서는 갑상선자극호르몬 분비가 증가하게 되어 갑상선 여포암이 잘 발병한다는 연구가 있습니다만,
                          <b>요오드 섭취가 직접적으로 갑상선암을 유발한다고 말할 수는 없습니다.</b></span>
                        <span><b>우리의 식습관과 갑상선암의 발병이 직접 연관되지는 않습니다.</b></span>
                        <span>다만, 갑상선암 수술 이후 요오드치료를 받아야 하는 경우
                          효과적인 치료를 위해 일정 기간 요오드가 든 음식을 제한할 필요는 있습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암을 진단 받은 후, 목이 매우 불편합니다. 서둘러 수술을 해야 할까요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선암은 매우 커지기 전까지는 특별한 증상이 없으며 림프절 전이가 있다고 할지라도 마찬가지입니다.</span>
                        <span>목의 이물감과 불편함은 갑상선암과는 관련이 없으며, <b>암 덩어리의 크기가 작고 전이 소견이 없으면 수술을 서둘러 할 필요는 없습니다.</b></span>
                        <span>하지만 후두신경 부위에 갑상선암이 위치해 있다면 신경을 침범할 수도 있는데,
                          <b>성대마비로 인해 목소리 변화</b>가 나타날 수 있습니다.</span>
                        <span>이미 많이 전이된 상태라고 해도 불편감을 유발하는 경우는 드물고, 목에 만져보면 통증이 없는 혹을 만질 수 있습니다.</span>
                        <span><b>초음파 및 CT검사에서 확인된 전이된 갑상선암은 수술을 되도록이면 빨리 진행</b>하는 것이 좋습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>임신 중에 발견한 갑상선암. 어떻게 해야 할까요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선암은 남성보다 여성에게서 더욱 많이 발병되므로, 간혹 임신을 한 상태에서 갑상선암을 발견할 수 있습니다.</span>
                        <span>갑상선암은 엄마의 암이 태아에게 전이되지는 않습니다.</span>
                        <span>아주 심각한 상태가 아니라면 임신기간에 굳이 갑상선암 수술을 할 필요는 없으며 1년 정도
                          지체되어도 예후에는 큰 차이가 없어서 분만 후까지 기다렸다가 수술하는 것이 일반적입니다.</span>
                        <span>만약, 심각한 상태일 경우에는 임신중에도 수술을 할 수 있는데, <b>임신 중기(특히 15주~24주 사이에 시행)</b>에 시행할 수 있습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암이 림프절로 전이되었다는데, 큰 흉터가 남는 림프절 절제술 대신 전이가 확인된 림프절만 제거하면 안되나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>림프절은 암이 퍼져 나가는 경로이기 때문에 <b>전이된 림프절과 주변 림프절을 제거하는 것은 암치료 과정이면서 재발방지에 도움</b>을 줍니다.</span>
                        <span>특히 <b>초음파검사나 CT에서 잘 보이지 않는 미세한 암 덩어리</b>들도 같이 없애기 위해서는 범위를 넓게 하여 수술해야 합니다.</span>
                        <span>림프절을 그렇게 제거하면 면역에 문제가 생기지는 않는지 걱정하시는 분들이 많지만, 림프절절제술로 제거되는 림프절은 몸에 있는
                          많은 림프절 중 극히 일부이기 때문에 면역체계에 문제를 일으키지 않습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>식사 때마다 턱 아래가 붓는다면 침샘에 문제가 생긴건가요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>음식을 먹을 때 턱 아래나 귀 아래가 붓는 증상은 침샘에서 침이 잘 배출되지 않을 때 생깁니다.</span>
                        <span>침샘에서 만들어진 침샘관을 따라 입으로 나오는데 <b>침샘관에 염증이 생기거나 돌이 생기면 침이 제대로 분비되지 못해 침샘이 붓게 됩니다.</b></span>
                        <span>식사할 때 침샘이 붓는다는 것은 침샘이 제 기능을 하고 있다는 의미이지만 이런 상태가 오래 지속되면 침샘이 점점 기능을 잃고 퇴화할 수 있기 때문에
                          <b>가급적 빨리 전문의와의 상담을 통해 문제가 되는 요인을 제거해야 침샘을 살릴 수 있습니다.</b></span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암 수술 후 얼마동안 입원하나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>땡큐서울의원의 갑상선암수술은 입원 기간이 비교적 짧은 편입니다.</span>
                        <span>이는 <b>경험 많은 교수 출신 전문의가 직접 수술</b>하여 수술 시간이 짧고, 따라서 마취시간도 짧으며
                          <b>전신마취 유지 과정을 전공의가 아닌 전문의가 직접 담당</b>하여 마취 후 회복이 빠르기 때문입니다.</span>
                        <span>갑상선 반절제술(엽절제술)과 전절제술의 경우 대부분 <b>1박2일</b> 입원하며,
                          전절제술에 림프절절제술(경부곽청술)을 포함한 경우에는 <b>2박3일 내지 4박5일</b> 입원합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선 검진은 무엇을 검사하는 것인가요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선 질환을 검사하기 위해 시행하는 기본적인 검사로는 <b>혈액검사</b>와 <b>갑상선 초음파검사</b>가 있습니다.</span>
                        <span><b>‘갑상선기능검사’</b>라고도 불리는 <b>혈액검사</b>는 <b>갑상선호르몬 수치를 검사해
                          갑상선의 기능 이상</b>을 검사하는 것이며, <b>갑상선 초음파검사</b>는 <b>갑상선에 결절</b>이 있는지 확인하는 검사입니다.</span>
                        <span>혈액검사로는 갑상선결절의 유무를 알 수 없으며 초음파검사로는 갑상선 기능의 이상을 알 수 없기 때문에,
                          전문의와의 상담 후 자신에게 필요한 검진을 골라서 받도록 하는 것이 좋습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>이하선 종양은 모두 수술해야 하나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>이하선 종양은 너무도 다양한 종류가 존재해 세포검사로는 암과의 구별을 위한 진단에 한계가 있습니다.</span>
                        <span>따라서 침샘종양이 있으면 <b>정확한 진단과 치료를 위해 수술로 제거한 후 이에 대한 조직검사를 시행</b>합니다.</span>
                        <span>수술 후 조직검사에서 침샘암으로 확진된 경우에는 암의 악성도, 진행 정도에 따라 방사선 치료를 추가하기도 합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선기능저하증은 언제까지 치료해야 하나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선기능저하증의 가장 흔한 이유가 되는 <b>만성갑상선염(하시모토 갑상선염)</b>의 경우
                          <b>평생 갑상선호르몬제를 복용하는 경우가 대부분</b>입니다. 그러나 일부 갑상선염(급성 또는 아급성 갑상선염)에서
                          나타나는 갑상선기능저하증의 경우에는 <b>일정 기간 치료 후 갑상선 기능이 회복되어 호르몬제의 복용을 중단할 수도</b> 있습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선기능저하증에 걸리면 불임이 되나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선기능저하증이 있으면 <b>생리주기가 불규칙해 질 수 있으며</b>
                          갑상선기능저하증이 심한 경우 <b>무배란이 동반되어 난임</b>으로 이어질 수 있습니다.</span>
                        <span>따라서 <b>임신을 준비 중인 여성이라면 갑상선기능검사를 시행하며 정상 갑상선 수치를 유지</b>하는 것이 반드시 필요합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>편도선 수술 시 전신마취가 걱정이에요.</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>편도선 수술은 <b>호흡기계를 보호하기 위하여 대부분 전신마취 하에</b> 이루어지게 됩니다.</span>
                        <span>전신마취는 <b>마취통증의학과 전문의와의 적절한 사전 검사</b>를 시행한다면 후유증이나 합병증에 대한
                          위험성에 대해서는 크게 걱정하지 않으셔도 좋습니다.</span>
                        <span>따라서 <b>마취통증의학과 전문의가 상주하여 수술 시작부터 종료까지 수술의 전 과정을 함께하는
                          의료기관</b>을 선택하는 것이 전신마취에 대한 걱정을 줄일 수 있는 좋은 방법입니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>성악가, 가수, 아나운서 등 전문음성사용인의 갑상선수술, 꼭 해야하나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>전문음성사용인에게 갑상선암이 발견된 경우 수술 시기와 범위에 대해 잘 고려해야 합니다.</span>
                        <span>수술 후 성대마비나 목소리 변화가 생길 수 있기 때문에 <b>작은 갑상선암은 섣불리 수술하지 않는 것</b>이 좋지만,
                          <b>갑상선암이 성대 신경과 닿아있는 위치에 있다면 수술을 적극적으로 고려</b>해야 합니다.</span>
                        <span>특히 갑상선 재수술은 목소리에 치명적이기 때문에 갑상선 반절제술보다는
                          <b>재발 확률을 낮출 수 있는 갑상선 전절제술</b>이 더 나은 선택일 수 있습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>목소리가 변하는 질환에는 어떤 것들이 있나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>목소리가 변하는 질환의 원인은 아주 많습니다.</span>
                        <span>그 중 대부분은 목감기로 인한 성대 점막의 염증으로 성대가 붓는 후두염인 경우가 많은데,
                          이러한 경우는 휴식을 취하면 자연스레 회복됩니다.</span>
                        <span><b>하지만 성대결절, 성대 폴립 등 성대에 문제가 생기는 질환</b>이나 <b>연축성발성장애,
                          성대 마비 처럼 성대신경에 원인이 있는 질환</b>인 경우에는 정확한 진단과 치료가 필요합니다.
                          드물게 후두암이 목소리 변화의 원인인 경우가 있으므로, 6주 이상 목소리 변화가 호전되지 않으면
                          꼭 검사를 받아야 합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선에 양성결절이 있다고 해요. 안심해도 될까요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>연구결과에 의하면 <b>갑상선 양성결절 중 1~2% 미만이 암으로 발전</b>할 수 있다고 합니다.</span>
                        <span>하지만 확률적으로 갑상선결절의 약 5%가 갑상선암임을 감안하면 기본의 갑상선 양성결절이
                          갑상선암으로 발전하는 경우보다는 <b>새로운 결절이 생기고 이 결절이 암으로 발전하는 경우가 훨씬 흔하다</b>고 할 수 있습니다.</span>
                        <span>따라서 이미 발견된 양성결절과는 별개로 전문의와의 상담을 통한 정기적인 갑상선 검진을 진행하는 것이 좋습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>건강검진 때 갑상선 혈액검사에서 아무 이상이 없었는데 갑상선암을 진단 받았습니다. 어떻게 갑상선암이 진단될 수 있나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span><b>갑상선 혈액검사</b>는 갑상선암이 아니라 <b>갑상선 기능을 검사</b>하는 것입니다.</span>
                        <span>즉, <b>갑상선호르몬의 수치를 측정하여 갑상선이 잘 기능하고 있는지 확인</b>하는 것이므로 갑상선암 검사와는 전혀 다른 검사입니다.</span>
                        <span>갑상선암 검사는 초음파검사나 세침흡인검사 등을 통해 갑상선의 모양이나 세포학적인 이상을 확인하는 것으로 혈액검사와 갑상선암 검사는 다르기 때문에
                          <b>혈액검사에서 이상이 없었더라도 갑상선암 검사에서 갑상선암을 진단받을 수 있습니다.</b></span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>후두암은 흡연과 관련이 있나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>흡연자라고 해서 모두 후두암에 걸리는 것은 아닙니다. 하지만 흡연자는 후두암에 대해 주의할 필요가 있습니다.</span>
                        <span>비흡연자가 후두암에 걸리는 일은 매우 드문 것으로 알려져 있을 만큼 <b>흡연은 후두암 발병의 중요한 원인</b>이기 때문입니다.</span>
                        <span><b>담배를 오래 피운만큼, 많이 피운만큼 후두암에 걸릴 가능성이 높아지므로</b> 주의하는 것이 좋습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암수술 후 목소리 재활은 빠를수록 좋은가요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선암수술 후 목소리 문제는 약 <b>80% 환자에서 발생</b>을 합니다. 이 중 10%의 환자는 성대 신경손상으로 인해
                          목소리가 나빠지게 되며, 신경 손상 대부분은 일시적이지만 드물게는 영구적으로 나타나기도 합니다.</span>
                        <span>본원에서 갑상선수술 환자를 대상으로 조기에 음성치료를 시행한 결과 설문지 점수를 수술 전과 수술 후를 비교했을 때
                          <b>호전된 환자가 57%로 나타나 갑상선수술 후 목소리가 좋아졌 다고 느끼는 환자가 절반이 넘었습니다.</b></span>
                        <span>갑상선수술 후 목소리가 변하고 불편을 느낀다면 기다리지 말고 빠른 시간안에 음성치료를 받는 것이 좋습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암의 원인은 무엇일까요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선암은 다른 암과 달리 술이나 담배의 영향과는 크게 상관이 없습니다.</span>
                        <span><b>갑상선암은 유전자의 이상과 관련</b>이 깊은데, 병원에 가서 검사하게 되는 X-Ray나 CT 등의 방사성 노출정도는 갑상선암 발생과 관련이 없습니다.</span>
                        <span>오히려, <b>부모가 갑상선암 환자일 때 자녀에게 갑상선암이 발생할 가능성이 10배정도까지 증가</b>할 수가 있습니다.</span>
                        <span>갑상선암의 종류 중 <b>수질암의 경우 약 20%정도는 RET 유전자 이상이며 가족력이 있는 것</b>으로 알려져 있습니다.</span>
                        <span>만약 RET 유전자 이상의 수질암이 발견되었다면 가족들도 RET 유전자 돌연변이를 검사하는 것이 좋습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>수술을 받았는데도 목에 뭔가 있는 느낌이 사라지지 않습니다. 이상이 있는 걸까요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선암 수술 이후 회복되는 과정에서 생기는 <b>근육 유착이 원인</b>일 수 있고, <b>신경통의 일종</b>일 수도 있습니다.</span>
                        <span><b>운동, 마사지, 스트레칭</b>을 지속적으로 하면 증상이 나아지며, 근육이 뭉치거나 유착된 부위가 확실하다면 <b>소염제 주사를 맞으면 단기간(1~2개월 정도) 도움이 됩니다.</b></span>
                        <span>보통 수술 이후 3~4개월 정도면 불편감이 사라지는데, 드물게 몇 년간 지속되기도 합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>목에 만져지는 멍울이 있다면?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>목에 만져지는 멍울이 있다면 지체없이 병원에서 확인을 하는 것이 좋습니다. 목의 멍울은 <b>다양한 질환으로 인해 생길 수 있으며
                          크게 염증성, 선천성, 종양성의 3가지</b>로 나뉘게 됩니다.</span>
                        <span>목의 멍울이 시간에 따라 커졌다 작아졌다 하는 경우나 만져서 아픈 경우
                          종양보다는 염증성일 가능성이 높습니다. 하지만 목의 멍울도 <b>두경부암이나 갑상선암 증상 중 하나</b>로,
                          통증이 없을 수 있기 때문에 자칫 늦게 발견되어 림프절 전이가 되었을 수도 있기 때문에
                          <b>목에 멍울이 만져진다면 초기 검사가 매우 중요합니다.</b></span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선 기능 항진증의 다양한 증상은 어떤 것들이 있을까요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선 기능 항진증의 가장 흔한 증상은 피로감입니다. 갑상선호르몬이 정상보다 많이 분비되어
                          쉽게 피로를 느끼며 위장관의 운동이 증가함에 따라 소화가 빨라 배가 고파질 수 있고
                          대변을 여러 번 보게 될 수 있으며 심할 경우 설사가 나타날 수 있습니다.</span>
                        <span>또한, 식욕이 증가하여 식사량이 증가하지만 체중이 감소하며, 열 발생이 많아져 더위를 참기 힘들고,
                          땀이 많이 나며 가벼운 운동에도 숨이 차거나 안정시에도 가슴이 두근거리는 증상을 동반하기도 합니다.</span>
                        <span>이외에도 신경이 매우 에민해져 사소한 일에 쉽게 흥분되거나 집중력이 떨어지고 불안감이
                        찾아올 수 있습니다.</span>
                        <span>뿐만 아니라 갑상선 기능 항진증의 1/3정도에서 안구돌출증이 동반되게 됩니다. 눈이 커지고 앞으로 돌출되며 눈꺼풀이 붓고 결막에 충혈이 나타나게 됩니다.</span>
                        <span>여성들의 경우 월경의 이상과 함께 몸이 더워지는 증상이 나타나며, 목 앞의 갑상선이 위치 한 부분이 점점 부어 오를 수 있습니다.</span>
                        <span class="small">(도움말: 내분비내과 이은정 원장)</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선암 수술 권유 받았습니다. 대학병원을 포함한 큰 병원과 개인의원 중 어떻게 선택해야 할까요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선암-두경부암을 수술하는 땡큐서울의원는 2016년 10월 10일 개원 이후
                          약 3년 동안 <b>1,763명의 환자가 입원 수술</b>을 받았으며 <b>2019년 9월까지 792건의
                          갑상선/갑상선암 수술을 시행</b>하였습니다.</span>
                        <span>크고 어려운 수술일수록 큰 병원 보다는 수술 경험이 많고 대학병원 교수 출신으로,
                          수술을 잘 하는 전문의가 수술의 처음부터 마무리까지 <b>직접 수행하는 수술 전문을 지향하는 병원</b>이 더 유리할 수 있습니다.</span>
                        <span>큰 병원보다는 수술시간 및 마취시간이 짧아 입원 기간이 짧고 일상생활에 빨리 복귀할 수 있습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>약으로 안되는 갑상선 기능 항진증, 수술하면 약 안 먹을 수 있나요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선 기능 항진증의 치료는 <b>항갑상선제를 이용한 약물치료, 방사성 요오드 치료, 수술</b>이 있습니다.</span>
                        <span><b>항갑상선제는 갑상선호르몬의 생산을 억제하는 약물</b>로 원인이 되는 자가면역항체에 대한
                          직접적인 치료는 아니나, 1년~1년 6개월 정도 치료하면 완치되는 경우가 많습니다.
                          하지만 약 복용을 중단하면 다시 재발하는 경우가 종종 있습니다. 비교적 안전한 약물이긴 하지만
                          무과립구증, 혈관염, 간기능장애 등의 부작용이 있을 수 있어서, 이러한 증상이 있거나
                          1년 6개월 동안 복용을 해도 치료가 되지 않으면 다른 방법을 고려해야 합니다.</span>
                        <span><b>방사성 요오드 치료와 수술은 갑상선을 없애는 치료</b>로 항진증에 대한 치료결과는
                          확실히 좋지만, 치료 후 갑상선이 없어지기 때문에 이후에는 평생 갑상선 기능 저하증 상태가 됩니다. 갑상선 기능 항진증 보다는 덜 위험하기 때문에 갑상선호르몬제를 복용하면 안정적으로 조절할 수 있습니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>두경부암 조기진단이 어려운 이유는 무엇인가요?</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span><b>두경부암은 한해 동안 약 5,000여명이 발병합니다.</b>
                          (2016년 5,058명 – 구강암 1,595명 / 후두암 1,167명 / 하인두암 399명 / 구인두암 572명 / 비인두암 408명 / 비강, 부비동암 348 명 / 침샘암 569명)</span>
                        <span>이비인후과 개원의는 약 3,000명이며 치과 개원의는 약 20,000명이 되는데 의사수에 비해 환자수가 너무 적어서</span>
                        <span class="small">(이비인후과 의사 3,000명 대 구강암 환자 1,595명) (치과의사 20,000명 대 구강암 환자 1,595명)</span>
                        <span>의사들이 두경부암 환자를 접할 기회가 매우 드뭅니다.</span>
                        <span>그래서 구강암을 먼저 의심하기 어렵고 흔한 구내염으로 진단내리기 쉽습니다.</span>
                        <span>따라서, <b>경험 많은 이비인후과(두경부외과) 전문의의 정확한 진단과 다양한 치료 경험이 매우 중요</b>합니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                  <accordion-item>
                    <template slot="accordion-trigger">
                      <div class="accordion-img">
                        <img src="@/assets/images/q.svg">
                      </div>
                      <h3>갑상선초음파검사에서 암이 의심되는 경우</h3>
                    </template>
                    <template slot="accordion-content">
                      <div class="accordion-img">
                        <img src="@/assets/images/a.svg">
                      </div>
                      <div class="answer_wrap">
                        <span>갑상선 초음파검사에서는 갑상선결절이 있는지 확인합니다.
                          결절이 있다면 액체로 된 낭성 (물혹)인지 고형(덩어리)인지 먼저 구별합니다.</span>
                        <span>초음파검사에서 저에코성(갑상선 색보다 짙은 회색)의 고형결절이 가시 모양으로
                          튀어 나온 경계면을 가지고 있고 세로 방향으로 길고 크기가 작은 미세석회가 있으면
                          갑상선암 중 유두암일 확률이 높습니다.
                          <b>결절의 크기와 개수는 암 확률과 관계가 없습니다.</b></span>
                        <span>낭성결절이라면 암일 가능성은 없으며 <b>고형결절이라면
                          크기, 초음파강도(에코성), 모양, 결절의 경계면, 길이가 긴 방향의 표시 방향,
                          석회화의 모양 등을 확인</b>하게 됩니다.</span>
                      </div>
                    </template>
                  </accordion-item>

                </accordion>
              </template>
            </accordion-item>
          </accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import Accordion from '@/components/Accordion'
import AccordionItem from '@/components/Accordion-item'
export default {
  data () {
    return {
      transDate: {
        headerName: '자주 묻는 질문',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  methods: {
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    Accordion,
    AccordionItem
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
